export var SET_TUBE_DATA = '[TUBE] SET DATA';
export var SET_BRANDING_COLOR = '[TUBE] SET COLOR';
export var UPDATE_TUBE = '[TUBE] UPDATE';
export function setTubeData(tube) {
    return function (dispatch) {
        dispatch({
            type: SET_TUBE_DATA,
            payload: tube,
        });
    };
}
export function setBrandingColor(color) {
    return function (dispatch) {
        dispatch({
            type: SET_BRANDING_COLOR,
            payload: color,
        });
    };
}
export function updateTube(tube) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_TUBE,
            payload: tube,
        });
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/actions/tube.actions.ts
// module id = 443
// module chunks = 81